import Navigation from "./Navigation";
import Link from "next/link";
import { Button } from "@material-ui/core";

const createDocumentButtonRight = (
  <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
    <Link href="/api-playground" passHref>
      <Button color="primary" variant="contained">
        API Playground
      </Button>
    </Link>
  </div>
);

export default function CreatorNavigation(props: {
  children: React.ReactChild | React.ReactChild[];
}) {
  return (
    <Navigation
      appBarChildrenWithPermanentDrawer={createDocumentButtonRight}
      appBarChildrenWithoutPermanentDrawer={createDocumentButtonRight}
    >
      {props.children}
    </Navigation>
  );
}
